import { ProfileCity } from 'app/design/icons/profile-city';
import { Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { type Profile } from 'app/network/profile';
import { type Statistics } from 'app/network/statistics';
import { theme } from './shared';
import type { ProfileNamespace } from './shared';
import { MemberSince } from './member-since';
import { ProfileActivitySectors } from './profile-activity-sectors';

export function MemberInfoCard({
  activitySectorsEnabled,
  isPlace,
  locationLabel,
  ns,
  profile,
  statistics,
}: {
  activitySectorsEnabled: boolean;
  isPlace: boolean;
  locationLabel: string;
  ns: ProfileNamespace;
  profile: Profile | undefined;
  statistics: Statistics | undefined;
}) {
  if (isPlace) return null;
  return (
    <Column
      gap="spacing.general.x3"
      style={{
        padding: theme.spacing['spacing.general.x3'],
        borderRadius: theme.borderRadii['radius.md'],
        borderWidth: 1,
        borderColor: theme.colors['surface.disabled'],
        backgroundColor: theme.colors['surface.tertiary-neutral'],
      }}
    >
      <Row alignItems="center" gap="spacing.general.x2">
        <ProfileCity color="#999999" width={18} height={18} />
        <Text variant="bodyBase" color="text.primary" flex={1}>
          {locationLabel}
        </Text>
      </Row>
      <MemberSince ns={ns} profile={profile} subscribed={statistics?.subscribed} />
      <ProfileActivitySectors enabled={activitySectorsEnabled} sectors={profile?.activitySectors} />
    </Column>
  );
}
